import ParametrizacaoCliente from '../../spa/parametrizacao/cliente/ParametrizacaoCliente';

export default {
  path: 'parametrizacao-cliente',
  name: 'parametrizacao-cliente',
  component: ParametrizacaoCliente,
};
